import { RectangleEllipsis } from "lucide-react";
import React from "react";

type ProviderIcon = string | React.ComponentType<{ className?: string }>;

export function getProviderIcon(provider: string = ""): ProviderIcon | null {
  switch (provider) {
    case "auth0":
      return RectangleEllipsis;

    case "google-apps":
      return "/images/auth0/avatars/google-avatar.png";
    case "google-oauth2":
      return "/images/auth0/sso/google-apps.png";
    case "waad":
      return "/images/auth0/sso/microsoft-entra-id.png";
    case "okta":
      return "/images/auth0/sso/okta.png";
    case "oidc":
      return "/images/auth0/sso/oidc.png";
    case "keycloak-samlp":
      return "/images/auth0/sso/keycloak.png";
    case "adfs":
      return "/images/auth0/sso/microsoft-adfs.png";
    case "pingfederate":
      return "/images/auth0/sso/pingfederate.png";
    case "samlp":
      return "/images/auth0/sso/samlp.png";
    case "windowslive":
      return "/images/auth0/avatars/microsoft-avatar.png";
    default:
      return null;
  }
}

export function formatProvider(provider: string = "") {
  switch (provider) {
    case "auth0":
      return "Email & Password";
    case "google-oauth2":
      return "Google";
    case "oidc":
      return "OIDC";
    case "samlp":
      return "SAML";
    case "waad":
      return "Microsoft Entra ID";
    case "google-apps":
      return "Google Workspace";
    case "adfs":
      return "Microsoft ADFS";
    case "okta":
      return "Okta";
    case "keycloak-samlp":
      return "Keycloak";
    case "pingfederate":
      return "PingFederate";
    case "windowslive":
      return "Microsoft";
    default:
      return provider;
  }
}
